import { CreateElement } from 'vue'
import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { lkTopicPermissions as Permissions } from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'
import { TOPICS_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_TOPICS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'topics',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "topics.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'view-topics-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "topics.list" */
          './TopicsList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: Permissions.read,
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "topics.view" */
          './TopicsView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        meta: {
          permission: Permissions.edit,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "topics.view" */
          './TopicsView.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        props: () => ({ viewType: TYPES.CREATE }),
        meta: {
          permission: Permissions.create,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "topics.view" */
          './TopicsView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
